export default __webpack_public_path__ + "static/media/awsCCP.e5c57c0f.jpeg";